export class Milliseconds {
  constructor(public readonly time: number = 0) {}

  public static fromDays(days: number): Milliseconds {
    const dayInMilliseconds = days * 24 * 60 * 60 * 1000;
    return new Milliseconds(dayInMilliseconds);
  }

  public add(milliseconds: number): Milliseconds {
    return new Milliseconds(this.time + milliseconds);
  }
}
